// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"898dd7dd","453":"a40da0b7","780":"d3fec613"}[chunkId] + ".chunk.js";
};